import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useRef } from 'react';
export function useFilePicker(param) {
    let { accept, onFileSelected, testId } = param;
    const inputRef = useRef(null);
    const openFilePicker = useCallback(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click();
    }, []);
    const handleChange = useCallback((e)=>{
        var _e_target_files;
        const file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file != null) {
            onFileSelected(file);
        }
        if (inputRef.current != null) {
            inputRef.current.value = '';
        }
    }, [
        onFileSelected
    ]);
    const fileInputElement = useMemo(()=>/*#__PURE__*/ _jsx("input", {
            ref: inputRef,
            type: "file",
            accept: accept,
            onChange: handleChange,
            "data-testid": testId,
            hidden: true
        }), [
        accept,
        handleChange,
        testId
    ]);
    return {
        openFilePicker,
        fileInputElement
    };
}
